module.exports = __webpack_public_path__ + "media/dorobek/assets/images/uczelnia-negatyw-38454454a503d433b0dc64ac58157202.svg";